<template>
  <autocomplete-field
    v-bind="$attrs"
    v-model="innerValue"
    :rules="rules"
    :vid="vid"
    :name="name"
    :label="label"
    :options="options"
    :options-limit="optionsLimit"
    :item-label="itemLabel"
    :item-value="itemValue"
    :multiple="multiple"
    :close-on-select="!multiple"
    :return-object="returnObject"
    :full-width="fullWidth"
    :max-result-shown="maxResultShown"
    :disabled="disabled"
    :searchable="searchable"
    :allow-empty="allowEmpty"
  />
</template>

<script>
import AutocompleteField from '@/components/fields/AutocompleteField'

export default {
  name: 'SelectField',
  components: {
    AutocompleteField
  },
  props: {
    modelValue: {
      type: [Object, Array, Number, String],
      default: null
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    itemLabel: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: null
    },
    rules: {
      type: String,
      default: null
    },
    vid: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    maxResultShown: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: true
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    optionsLimit: {
      type: Number,
      default: 200  // 検索機能のパフォーマンスに関わる
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {}
  },
  computed: {
    innerValue: {
      get () {
        return this.modelValue
      },
      set (newValue) {
        return this.$emit('update:modelValue', newValue)
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
